<script setup lang="ts">
import { InterfaceUser } from '~/classes/users/InterfaceUser'

// TODO: loading state for this so that we don't see it pop in asynchronously once user info
// is available
const { navSharingViewTestId } = useTestId()
const { state: savedUserState } = useSavedUsers()
const { currentSharedFolderHome } = useNavigation()
const users = computed(() => currentSharedFolderHome.value?.sharedWithUserRoles() ?? {})
const active = ref(false)

const user = (userId: string) => savedUserState.value.publicUserInfo[userId] ?? InterfaceUser.blank(userId)
</script>

<template>
  <dropdown
    anchor-x="right"
    anchor-y="bottom"
    flow-x="left"
    flow-y="down"
  >
    <template #default="{ open }">
      <nav-pill v-if="len(users)">
        <nav-pill-button
          :data-testid="navSharingViewTestId"
          class="sharing-menu-button"
          @click="open()"
        >
          <div class="user-bubble-container">
            <user-avatar
              v-for="{ userId } of users"
              :key="userId"
              :user="user(userId)"
              :size="24"
              class="user-bubble"
            />
          </div>
        </nav-pill-button>
      </nav-pill>
    </template>
    <template #menu>
      <nav-sharing-dropdown class="sharing-dropdown" />
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.user-bubble-container
  @apply flex h-full px-1.5 group flex-row-reverse justify-end items-center
.user-bubble
  @apply outline outline-2 outline-[#212122] h-full group-hover:outline-[#66696d] z-1 -mx-1.5
  &:not(:last-child)
    @apply ml-0

.sharing-dropdown
  @apply my-2
</style>
